var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownloadGooglestoreWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 37,
    viewBox: "0 0 155 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3295 5.39237C50.3295 6.47787 49.9966 7.34725 49.3408 7.99563C48.5869 8.76425 47.6049 9.151 46.4015 9.151C45.2514 9.151 44.2695 8.75775 43.4639 7.98262C42.6567 7.19612 42.2539 6.23087 42.2539 5.0755C42.2539 3.92012 42.6567 2.95488 43.4639 2.17488C44.2695 1.39325 45.2514 1 46.4015 1C46.9741 1 47.52 1.11538 48.0409 1.32988C48.5602 1.546 48.983 1.8385 49.2892 2.19925L48.5935 2.885C48.0592 2.26913 47.3319 1.96525 46.4015 1.96525C45.5627 1.96525 44.8354 2.25125 44.2179 2.82812C43.607 3.40662 43.3008 4.15575 43.3008 5.0755C43.3008 5.99525 43.607 6.75087 44.2179 7.32937C44.8354 7.89975 45.5627 8.19225 46.4015 8.19225C47.292 8.19225 48.0409 7.89975 48.6318 7.32287C49.0213 6.941 49.2426 6.4145 49.3009 5.74175H46.4015V4.8025H50.2695C50.3161 5.00562 50.3295 5.20225 50.3295 5.39237Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4666 2.13584H52.8333V4.60584H56.1088V5.54508H52.8333V8.01508H56.4666V8.97221H51.8047V1.17871H56.4666V2.13584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7962 8.97221H59.7677V2.13584H57.5391V1.17871H63.0265V2.13584H60.7962V8.97221Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.998 8.97221V1.17871H68.025V8.97221H66.998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5775 8.97221H71.5572V2.13584H69.3203V1.17871H74.8144V2.13584H72.5775V8.97221Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2033 7.96962C84.416 8.75775 83.4407 9.151 82.2773 9.151C81.1073 9.151 80.1319 8.75775 79.3447 7.96962C78.5591 7.18312 78.168 6.21787 78.168 5.0755C78.168 3.93312 78.5591 2.96787 79.3447 2.18138C80.1319 1.39325 81.1073 1 82.2773 1C83.4341 1 84.4094 1.39325 85.1966 2.18787C85.9889 2.98087 86.38 3.93962 86.38 5.0755C86.38 6.21787 85.9889 7.18312 85.2033 7.96962ZM80.1053 7.31637C80.6978 7.89975 81.4185 8.19225 82.2773 8.19225C83.1295 8.19225 83.8568 7.89975 84.4427 7.31637C85.0335 6.733 85.3331 5.98387 85.3331 5.0755C85.3331 4.16712 85.0335 3.418 84.4427 2.83463C83.8568 2.25125 83.1295 1.95875 82.2773 1.95875C81.4185 1.95875 80.6978 2.25125 80.1053 2.83463C79.5145 3.418 79.2149 4.16712 79.2149 5.0755C79.2149 5.98387 79.5145 6.733 80.1053 7.31637Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8223 8.97221V1.17871H89.0705L92.9519 7.23996H92.9968L92.9519 5.74171V1.17871H93.9788V8.97221H92.9069L88.8425 2.61196H88.7976L88.8425 4.11671V8.97221H87.8223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9149 20.354C74.7875 20.354 72.2327 22.6777 72.2327 25.8838C72.2327 29.064 74.7875 31.4121 77.9149 31.4121C81.0489 31.4121 83.6037 29.064 83.6037 25.8838C83.6037 22.6777 81.0489 20.354 77.9149 20.354ZM77.9149 29.2346C76.1989 29.2346 74.7226 27.8517 74.7226 25.8838C74.7226 23.89 76.1989 22.5315 77.9149 22.5315C79.6309 22.5315 81.1138 23.89 81.1138 25.8838C81.1138 27.8517 79.6309 29.2346 77.9149 29.2346ZM65.517 20.354C62.3829 20.354 59.8348 22.6777 59.8348 25.8838C59.8348 29.064 62.3829 31.4121 65.517 31.4121C68.6493 31.4121 71.1991 29.064 71.1991 25.8838C71.1991 22.6777 68.6493 20.354 65.517 20.354ZM65.517 29.2346C63.7993 29.2346 62.318 27.8517 62.318 25.8838C62.318 23.89 63.7993 22.5315 65.517 22.5315C67.2329 22.5315 68.7092 23.89 68.7092 25.8838C68.7092 27.8517 67.2329 29.2346 65.517 29.2346ZM50.7639 22.0488V24.3986H56.511C56.3429 25.7116 55.8935 26.6768 55.2045 27.3496C54.3656 28.1621 53.0591 29.064 50.7639 29.064C47.2271 29.064 44.4576 26.2771 44.4576 22.824C44.4576 19.3708 47.2271 16.584 50.7639 16.584C52.6763 16.584 54.0677 17.3136 55.0946 18.2593L56.7906 16.6035C55.3543 15.2645 53.4436 14.2358 50.7639 14.2358C45.9139 14.2358 41.8379 18.0887 41.8379 22.824C41.8379 27.5592 45.9139 31.4121 50.7639 31.4121C53.3853 31.4121 55.3543 30.5736 56.9021 29.0006C58.4883 27.452 58.9826 25.2745 58.9826 23.5162C58.9826 22.9702 58.936 22.4681 58.8528 22.0488H50.7639ZM111.091 23.8705C110.623 22.6338 109.18 20.354 106.241 20.354C103.328 20.354 100.903 22.5948 100.903 25.8838C100.903 28.9811 103.303 31.4121 106.521 31.4121C109.122 31.4121 110.623 29.8635 111.241 28.9616L109.31 27.7055C108.666 28.6252 107.789 29.2346 106.521 29.2346C105.261 29.2346 104.357 28.6707 103.778 27.5592L111.352 24.4993L111.091 23.8705ZM103.368 25.7116C103.303 23.5796 105.064 22.4876 106.326 22.4876C107.314 22.4876 108.153 22.9702 108.433 23.6608L103.368 25.7116ZM97.2116 31.0757H99.7016V14.8257H97.2116V31.0757ZM93.1339 21.5857H93.0507C92.4915 20.939 91.4246 20.354 90.0732 20.354C87.2371 20.354 84.644 22.785 84.644 25.9017C84.644 29.0006 87.2371 31.4121 90.0732 31.4121C91.4246 31.4121 92.4915 30.8222 93.0507 30.156H93.1339V30.949C93.1339 33.0631 91.9772 34.199 90.1114 34.199C88.5902 34.199 87.6465 33.1265 87.257 32.2246L85.0917 33.107C85.7158 34.5727 87.3685 36.3765 90.1114 36.3765C93.0307 36.3765 95.494 34.6995 95.494 30.6191V20.6903H93.1339V21.5857ZM90.2862 29.2346C88.5702 29.2346 87.1339 27.8322 87.1339 25.9017C87.1339 23.9533 88.5702 22.5315 90.2862 22.5315C91.9772 22.5315 93.3104 23.9533 93.3104 25.9017C93.3104 27.8322 91.9772 29.2346 90.2862 29.2346ZM122.748 14.8257H116.793V31.0757H119.276V24.9186H122.748C125.506 24.9186 128.211 22.9702 128.211 19.8713C128.211 16.7741 125.499 14.8257 122.748 14.8257ZM122.813 22.6582H119.276V17.0861H122.813C124.667 17.0861 125.726 18.5892 125.726 19.8713C125.726 21.1291 124.667 22.6582 122.813 22.6582ZM138.164 20.3231C136.369 20.3231 134.504 21.0966 133.736 22.811L135.94 23.7128C136.414 22.811 137.286 22.5185 138.209 22.5185C139.497 22.5185 140.803 23.2741 140.823 24.6082V24.7788C140.374 24.5253 139.412 24.15 138.229 24.15C135.855 24.15 133.437 25.4256 133.437 27.8062C133.437 29.9837 135.381 31.3861 137.566 31.3861C139.237 31.3861 140.159 30.65 140.738 29.7936H140.823V31.0497H143.222V24.8162C143.222 21.9351 141.018 20.3231 138.164 20.3231ZM137.864 29.2281C137.052 29.2281 135.92 28.8348 135.92 27.8517C135.92 26.594 137.331 26.1113 138.553 26.1113C139.647 26.1113 140.159 26.347 140.823 26.6573C140.629 28.1621 139.302 29.2281 137.864 29.2281ZM151.96 20.679L149.105 27.7233H149.02L146.069 20.679H143.391L147.825 30.5232L145.295 36.0011H147.89L154.722 20.679H151.96ZM129.575 31.0757H132.065V14.8257H129.575V31.0757Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08819 1.87613C0.697057 2.27588 0.470703 2.89825 0.470703 3.70425V32.4538C0.470703 33.2598 0.697057 33.8821 1.08819 34.2819L1.18472 34.3696L17.6853 18.2659V17.8856L1.18472 1.78188L1.08819 1.87613Z",
    fill: "url(#paint0_linear_8648_10359)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 23.6362L17.6855 18.2656V17.8854L23.1863 12.5147L23.3095 12.5846L29.8238 16.2035C31.6829 17.2305 31.6829 18.9205 29.8238 19.954L23.3095 23.5664L23.1797 23.6362Z",
    fill: "url(#paint1_linear_8648_10359)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.309 23.5664L17.685 18.0755L1.08789 34.2817C1.70537 34.9154 2.71232 34.9918 3.85741 34.358L23.309 23.5664Z",
    fill: "url(#paint2_linear_8648_10359)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.309 12.5848L3.85741 1.79319C2.71232 1.16594 1.70537 1.24231 1.08789 1.87606L17.685 18.0757L23.309 12.5848Z",
    fill: "url(#paint3_linear_8648_10359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8648_10359",
    x1: 16.2203,
    y1: 32.7531,
    x2: -5.59059,
    y2: 10.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8648_10359",
    x1: 32.2447,
    y1: 18.0737,
    x2: 0.0265246,
    y2: 18.0737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8648_10359",
    x1: 20.2508,
    y1: 15.0906,
    x2: -9.32646,
    y2: -15.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8648_10359",
    x1: -3.08996,
    y1: 43.8466,
    x2: 10.1176,
    y2: 30.3191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadGooglestoreWhite);
export default __webpack_public_path__ + "static/media/ic-download-googlestore-white.fed773163a750aac5864f22aa2adbc17.svg";
export { ForwardRef as ReactComponent };